module.exports = "/images/cmrad_logo_long.png?31d74da3abe4e34584a4d158e3be72d1";